<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <p>① 画面上部のメインメニューバーにある「ログアウト」アイコンを押すと、ログアウトメッセージが表示されます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\logout_new_1.png" alt="" /></div>
                <div>
                    <p>② 「OK」ボタンを押すと、アカウントがログアウトされます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\logout_new_2.png" alt="" /></div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <p>① 画面下部のメニューアイコンを押すと、画面の左側からメニューバーが表示されます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\logout_new_mb_1.png" alt="" /></div>
                <div>
                    <p>② 上部のログアウトアイコンをクリックすると、ログアウトメッセージが表示されます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\logout_new_mb_2.png" alt="" /></div>
                <div>
                    <p>③  「OK」ボタンを押すと、アカウントがログアウトされます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\logout_new_mb_3.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/logout_manual.vue